import React, { useState, useRef, useEffect } from 'react';
import { Search, X, Plus } from 'lucide-react';
import { coincideBusqueda } from '../utils/buscar';

export default function SearchSelect({
  options = [],
  value,
  onChange,
  placeholder = 'Buscar...',
  onCreate,
  createLabel = 'Crear nuevo',
}) {
  const [query, setQuery]   = useState('');
  const [open, setOpen]     = useState(false);
  const containerRef        = useRef();

  const selected = options.find(o => String(o.id) === String(value));

  useEffect(() => {
    const close = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setQuery('');
      }
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  // Busca por palabras sueltas, sin acentos y en cualquier orden: escribir
  // "Ricardo Griffith" encuentra "Ricardo Antonio Griffith Chávez". Ver utils/buscar.js
  const filtered = options.filter(o => coincideBusqueda(`${o.nombre ?? ''} ${o.meta ?? ''}`, query));

  const handleSelect = (opt) => {
    onChange(opt.id);
    setQuery('');
    setOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange('');
    setQuery('');
    setOpen(false);
  };

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <Search size={14} style={{
          position: 'absolute', left: 10, top: '50%',
          transform: 'translateY(-50%)', color: 'var(--silver)', pointerEvents: 'none',
        }} />
        <input
          className="form-input"
          style={{ paddingLeft: 32, paddingRight: value ? 32 : 12 }}
          value={open ? query : (selected?.nombre || '')}
          placeholder={placeholder}
          onFocus={() => { setOpen(true); setQuery(''); }}
          onChange={e => { setQuery(e.target.value); setOpen(true); }}
        />
        {value && !open && (
          <button onClick={handleClear} style={{
            position: 'absolute', right: 8, top: '50%',
            transform: 'translateY(-50%)', background: 'none',
            border: 'none', cursor: 'pointer', color: 'var(--silver)',
            display: 'flex', alignItems: 'center', padding: 0,
          }}>
            <X size={14} />
          </button>
        )}
      </div>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 1050,
          background: 'var(--navy-grad)', border: '1px solid rgba(var(--silver-rgb),0.25)',
          borderRadius: 8, maxHeight: 220, overflowY: 'auto',
          boxShadow: '0 8px 28px rgba(0, 0, 0, 0.5)',
        }}>
          {filtered.length === 0 && (
            <div style={{ padding: '10px 14px', color: 'var(--silver)', fontSize: 13 }}>
              Sin resultados
            </div>
          )}
          {filtered.map(opt => (
            <button
              key={opt.id}
              onMouseDown={() => handleSelect(opt)}
              style={{
                display: 'block', width: '100%', padding: '9px 14px', textAlign: 'left',
                background: String(opt.id) === String(value) ? 'rgba(var(--sky-rgb),0.25)' : 'transparent',
                border: 'none', cursor: 'pointer', color: 'var(--text)',
                fontSize: 13, fontFamily: 'var(--font)',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(var(--sky-rgb),0.18)'; }}
              onMouseLeave={e => {
                e.currentTarget.style.background = String(opt.id) === String(value)
                  ? 'rgba(var(--sky-rgb),0.25)' : 'transparent';
              }}
            >
              {opt.nombre}
              {opt.meta && (
                <span style={{ fontSize: 11, color: 'var(--sky-light)', marginLeft: 8, fontWeight: 400 }}>
                  {opt.meta}
                </span>
              )}
            </button>
          ))}
          {onCreate && (
            <button
              onMouseDown={onCreate}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                width: '100%', padding: '9px 14px', textAlign: 'left',
                borderTop: '1px solid rgba(var(--silver-rgb),0.15)',
                borderLeft: 'none', borderRight: 'none', borderBottom: 'none',
                background: 'transparent', cursor: 'pointer',
                color: 'var(--sky)', fontSize: 13, fontFamily: 'var(--font)', fontWeight: 600,
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(var(--sky-rgb),0.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
            >
              <Plus size={14} /> {createLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
